module.exports = __webpack_public_path__ + "img/SAU.693c1f0f.svg";